export default "__VITE_ASSET__BJO3G57J__"